<template>
    <span class="label text-white m-r-xs none-radius inline prod-label" :class="statusClass">
        {{ code }} <span v-if="qty" class="text-xs text-muted">({{qty}})</span>
    </span>
</template>

<script>

export default {
    name: 'ProductCodeBox',

    props: {
        code: String,
        qty: Number
    },

    computed: {
        statusClass: function () {
            const c = {};
            if (!this.code) return c;
            if (this.code == 'FKA') c['c-blue'] = true;
            else if (this.code == 'FK') c['c-yellow'] = true;
            else if (this.code == 'FKP') c['c-green'] = true;
            else if (this.code == 'FP') c.primary = true;
            else if (this.code == 'WFKA') c['light-red'] = true;
            else if (this.code == 'WŁ') c['light-neavy'] = true;
            else if (this.code == 'FKM') c['light-yellow'] = true;
            else if (this.code == 'to-confirm') c['text-red'] = true;
            return c;
        }
    }
}
</script>
<style scoped lang="scss">
</style>
